module.exports = __webpack_public_path__ + "img/throughthehill.498e3185.png";